import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import indexGenerics, {Params as BaseParams} from '../generics/index';

import ActorCategory from '../../../domain/entities/ActorCategory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

import NetActorCategoriesRepository from '../../../data/repositories/NetActorCategoriesRepository';

const types = {
  failure: Types.IndexActorCategoriesFailure,
  request: Types.IndexActorCategoriesRequest,
  success: Types.IndexActorCategoriesSuccess,
};

export interface Params extends BaseParams {
  id?: number | null;
  parentId?: number | null;
}

export default function action(
  params: Params,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<PaginatedResult<ActorCategory>> {
  return indexGenerics(new NetActorCategoriesRepository(), types, params);
}
